// extracted by mini-css-extract-plugin
var _1 = "RentalPortalApplicantPortalCell-modulelogo__tqZiD";
export { _1 as "logo" }
